import {
  Grid,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";

import useStyles from "./style";


const Searchbar = ({word,setWord,type,setType,finalWord,setFinalWord}) => {
  const classes = useStyles();

  const submit = (e) => {
    e.preventDefault();
    setFinalWord(word);
  };

  return (
    <>
      <Grid container className={classes.searchbar}>
        <Typography variant="h6">
          Enter or speak a word to lookup and what you want...
        </Typography>
        <form onSubmit={(e) => submit(e)} className={classes.box}>
          <label>Enter a Word</label>
          <input
            value={word}
            className={classes.formFeild}
            type="text"
            placeholder="Example..."
            onChange={(e) => setWord(e.target.value)}
          />
          <label>What you want?</label>
          <select
            value={type}
            className={classes.formFeild}
            onChange={(e) => setType(e.target.value)}
          >
            {/* <option value="everthing">Everthing</option> */}
            <option value="definitions">Definitions</option>
            <option value="synonyms">Synonyms</option>
            <option value="examples">Examples</option>
            <option value="rhymes">Rhymes</option>
            <option value="antonyms">Antonyms</option>
          </select>
          <button className={classes.submitBtn} type="submit">
            SEARCH WORD
          </button>
        </form>
      </Grid>
    </>
  );
};

export default Searchbar;
